import { createFileRoute } from "@tanstack/react-router";
import { ModelsPage } from "@/features/models/ModelsPage";
import { lineageQuery } from "@/lib/api/queries";
import { DEFAULT_ENV, projectSearch } from "@/lib/search";

export const Route = createFileRoute("/w/$workspace/p/$project/models/")({
  validateSearch: projectSearch,
  loaderDeps: ({ search: s }) => ({ env: s.env ?? DEFAULT_ENV }),
  loader: ({ context, params, deps }) =>
    context.queryClient.ensureQueryData(lineageQuery(params.workspace, params.project, deps.env)),
  component: () => {
    const { workspace, project } = Route.useParams();
    const s = Route.useSearch();
    return <ModelsPage workspace={workspace} project={project} env={s.env ?? DEFAULT_ENV} />;
  },
});
